<mat-tab-group>
  <mat-tab label="Edit"> </mat-tab>
</mat-tab-group>
<div class="common-container">
  <p class="common-info">
    <a class="nav-back" routerLink="/workspaces/template" aria-label="Go back to template list">
      <mat-icon>arrow_back</mat-icon>
    </a>
    Overview the exising template versions.
  </p>
</div>
<div class="centered-content">
  <mat-expansion-panel [expanded]="isExpansionPanelOpen" class="collection-panel">
    <mat-expansion-panel-header (click)="isExpansionPanelOpen = !isExpansionPanelOpen">
      <mat-panel-description>
        <mat-icon class="panel-icon">bookmark_manager</mat-icon>
      </mat-panel-description>
      Add new version
    </mat-expansion-panel-header>
    <div class="document-content">
      <app-template-form
        [loading]="loading"
        submitButtonText="Create new version"
        (formSubmit)="onSubmit($event)">
      </app-template-form>
    </div>
  </mat-expansion-panel>

  <div class="view-controls">
    @if (isLoading$ | async) {
      <mat-spinner diameter="40"></mat-spinner>
    }
    <button mat-icon-button class="view-change" type="button" (click)="isListView = !isListView">
      @if (isListView) {
        <mat-icon>view_module</mat-icon>
      } @else {
        <mat-icon>list</mat-icon>
      }
    </button>
  </div>
  <div class="template-content" [class.list-view]="isListView">
    @if (templatesData$ | async; as templates) {
      @if (templates.length) {
        @if (isListView) {
          <!-- List View -->
          <div class="list-layout">
            @for (template of templates; track template.version) {
              <app-template-list-element [isLink]="false" [template]="template"></app-template-list-element>
            }
          </div>
        } @else {
          <!-- Grid View -->
          <div class="grid-layout">
            @for (template of templates; track template.version) {
              <app-template-card [isLink]="false" [template]="template"></app-template-card>
            }
          </div>
        }
      } @else {
        <div class="no-data">
          <p>No templates found.</p>
        </div>
      }
    }
  </div>
</div>
